import { useQuery } from '@tanstack/react-query';

import { NEW_USER_QUIZ_API } from '@/shared/api/newUserQuiz';

const NEW_USER_QUIZ_STATUS_QUERY_KEY = ['newUserQuiz', 'status'] as const;

export const getNewUserQuizStatusQueryKey = (accountId?: string) =>
  [...NEW_USER_QUIZ_STATUS_QUERY_KEY, accountId] as const;

export const useNewUserQuizStatus = (accountId: string | undefined, enabled: boolean) =>
  useQuery({
    enabled: enabled && Boolean(accountId),
    queryFn: NEW_USER_QUIZ_API.getStatus,
    queryKey: getNewUserQuizStatusQueryKey(accountId),
    refetchOnMount: 'always',
    retry: false,
  });
